import { useState } from "react"
import PropTypes from "prop-types"
import FilterButton from "./FilterButton"
import FilterBadgeContent from "./FilterBadgeContent"
import { Checkbox } from "components/ui"
import { isBlank } from "utils/helpers"

export const DISCOUNT_KIND = "discount"

export const discountBadge = (selected, options) => {
  const names = options.filter(o => selected.value.includes(o.id.toString())).map(o => o.name)

  return <FilterBadgeContent label="Discount" value={names.join(", ")} />
}

const DiscountOptions = ({ onSubmit, options = [] }) => {
  const [value, setValue] = useState([])

  const handleSelect = e => {
    if (e.target.checked) {
      setValue([...value, e.target.value])
    } else {
      setValue(value.filter(v => v !== e.target.value))
    }
  }

  const handleSubmit = () => {
    onSubmit({
      value,
      label: discountBadge({ value }, options),
      kind: DISCOUNT_KIND
    })

    setValue([])
  }

  return (
    <>
      <h5 className="m-0 label">Include</h5>
      {options.map(option => (
        <Checkbox
          key={option.id}
          name={`discount_${option.id}`}
          htmlFor={`discount_${option.id}`}
          text={option.name}
          value={option.id.toString()}
          checked={value.includes(option.id.toString())}
          onSelect={handleSelect}
          labelClasses="mb-1 ws-n"
        />
      ))}
      <FilterButton disabled={isBlank(value)} onSubmit={handleSubmit} />
    </>
  )
}

DiscountOptions.propTypes = {
  onSubmit: PropTypes.func,
  options: PropTypes.array
}

export default DiscountOptions
